import { html } from 'lit';
import { Loader } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-loader')
export class PdsIconLoader extends PdsIcon {
  @state()
  icon = Loader;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
